<template>
  <div class="discount_setting__modal">
    <vs-popup id="discount_setting" title="Discount Setting" button-accept="false" button-cancel="false" :active.sync="isActive">
      <div>
        <form>
          <div class="vx-row pt-5 px-5">
            <div class="vx-col w-full px-8">
              <!-- discount type -->
              <div class="vx-row mb-2">
                <label for="">Discount Type</label>
                <select-2
                  autocomplete
                  class="w-full"
                  placeholder="Select Discount Type"
                  :value="form.discountType"
                  @input="(item) => handleDiscountTypeChange(item)"
                  :options="discountTypeOptions"
                  name="Discount Type"
                  v-validate="'required'"
                />
                <span class="text-danger text-sm" v-show="errors.has('Discount Type')">{{ errors.first('Discount Type') }}</span>
              </div>

              <!-- discount amount -->
              <div class="vx-row mb-2">
                <label for="">Discount Amount</label>
                <vs-input type="number" class="w-full mb-1" v-model="form.discountAmount" @blur="(e) => handleDiscountAmountChange(e)" name="Discount Amount" v-validate="'required'" />
                <span class="text-danger text-sm" v-show="errors.has('Discount Type')">{{ errors.first('Discount Type') }}</span>
              </div>

              <!-- amount type -->
              <div class="vx-row mb-2">
                <div class="flex w-full">
                  <div class="mr-4" name="">
                    <vs-radio v-model="form.amountType" vs-value="preTax" name="Amount Type" v-validate="'required'">Pre Tax</vs-radio>
                  </div>
                  <div class="mr-4" name="">
                    <vs-radio v-model="form.amountType" vs-value="postTax" name="Amount Type" v-validate="'required'">Post Tax</vs-radio>
                  </div>
                </div>
                <span class="text-danger text-sm" v-show="errors.has('Amount Type')">{{ errors.first('Amount Type') }}</span>
              </div>

              <!-- action -->
              <div class="vx-row mt-5 justify-center">
                <vs-button type="filled" color="danger" @click="applyDiscounts"> Apply Discount </vs-button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { discountTypeOptions } from '@/utils/enums'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import { paymentMixins } from '@/utils/paymentTypes'

export default {
  name: 'DiscountSettingModal',

  props: {
    isModalShow: Boolean,
    item: Object
  },

  components: {
    Select2
  },

  data() {
    return {
      discountTypeOptions,

      form: {
        discountType: null,
        discountAmount: 0,
        amountType: null
      }
    }
  },

  mixins: [paymentMixins],

  mounted() {
    this.form = {
      discountType: this.item.discountType,
      discountAmount: this.item.discount,
      amountType: this.item.discountAmountType ? this.item.discountAmountType : null
    }
  },

  computed: {
    isActive: {
      get() {
        return this.isModalShow
      },

      set(val) {
        this.$emit('update:isModalShow', val)
      }
    },

    // validate form
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    async applyDiscounts() {
      if (!(await this.$validator.validate())) {
        return false
      }

      // update item discount
      this.$emit('update-item-discount', {
        discountType: this.form.discountType,
        discount: Number(this.form.discountAmount),
        discountAmountType: this.form.amountType ? this.form.amountType : null
      })

      this.isActive = false
    },

    // handle change discount type
    handleDiscountTypeChange(data) {
      this.form.discountType = data.value
      this.form.discountAmount = 0
    },

    // handle discount amount change
    handleDiscountAmountChange(e) {
      const newVal = Number(e.target.value)

      // check negative value
      if (newVal < 0) {
        return false
      }

      // check item quantity
      if (this.item.itemQuantity <= 0) {
        this.$vs.notify({
          title: 'Error',
          text: 'Please select product quantity first',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })

        return false
      }

      this.form.discountAmount = newVal < 4 ? newVal : paymentMixins.methods.mathRound(newVal, 2)
    }
  }
}
</script>

<style lang="scss">
#discount_setting {
  .vs-popup {
    width: calc(100% - 70%) !important;
  }

  .vs-popup--header {
    background: rgb(0, 102, 34);
    border-radius: unset;
    padding: 0px;

    h3 {
      color: #fff;
      text-align: center;
    }
  }
}
</style>